































import { Enrollment } from '@/models/enrollments/enrollment.interface';
import { EnrollmentStatusEnum } from '@/shared/models';
import { Alert } from '@conversa/bedazzled/src/alerts';
import { Dialog, DialogActions } from '@conversa/bedazzled/src/dialog';
import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
  props: {
    enrollment: {
      required: true,
      type: Object as PropType<Enrollment>,
    },
    loading: {
      type: Boolean,
    },
    error: {
      type: String,
    },
  },
  components: {
    Alert,
    Dialog,
    DialogActions,
  },
  emits: ['update-status'],
  setup({ enrollment }, ctx) {
    const enrolled =
      enrollment.approvalStatus === EnrollmentStatusEnum.Approved;
    const authoringId = enrollment.surveyAuthoringId;

    return {
      enrolled,
      authoringId,
      enableClose: false,
      dialogText: enrolled
        ? {
            title: 'Unenroll?',
            description:
              'Are you sure you want to unenroll the patient from this program? Unenrolling the patient will stop all program communications. In the future you will be able to reenroll the patient.',
            button: 'Unenroll Patient',
            loading: 'Unenrolling Patient...',
            errorMessage:
              'Something went wrong. Please try again, or try contacting your Customer Success representative.',
          }
        : {
            title: 'Re-enroll?',
            description:
              'The patient was previously unenrolled from this program. Would you like to re-enroll this patient?',
            button: 'Continue',
            loading: 'Continuing...',
            errorMessage:
              'Something went wrong. Please try again, or try contacting your Customer Success representative.',
          },
      cancel: () => ctx.emit('dialog-closed'),
    };
  },
});
